import {HttpInterceptorFn, HttpResponse} from '@angular/common/http';
import {filter} from 'rxjs';
import {map} from 'rxjs/operators';
import {LocalStorageKeys} from '../../global/storage.service';

export const EXPIRED_SESSION_AT_HEADER_NAME = 'X-Session-Expires-At';
export const collectSessionExpirationInterceptor: HttpInterceptorFn = (req, next) => {


    return next(req.clone())
        .pipe(
            filter(event => event instanceof HttpResponse),
            map( (response:HttpResponse<unknown>) =>{
                    if(response.headers.has(EXPIRED_SESSION_AT_HEADER_NAME)){
                        const timestamp = response.headers.get(EXPIRED_SESSION_AT_HEADER_NAME);
                        if(timestamp?.length > 0) {
                            localStorage.setItem(LocalStorageKeys.SESSION_EXPIRE_AT, timestamp);
                        }
                    }

                    return response;
            })
        );
};
